(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-kith"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-kith')) {
    class ProductFormKith extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = this.querySelector('form');
        const variantsEl = document.getElementById('ProductVariants-' + this.sectionId);
        this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

        this.querySelectorAll('.kith-pdp__opt-btn').forEach((btn) => {
          btn.addEventListener('click', () => this.handleOptionClick(btn));
        });

        this.qtyInput = this.querySelector('.kith-pdp__qty-input');
        const decreaseBtn = this.querySelector('[data-qty-decrease]');
        const increaseBtn = this.querySelector('[data-qty-increase]');
        if (decreaseBtn) decreaseBtn.addEventListener('click', () => this.stepQty(-1));
        if (increaseBtn) increaseBtn.addEventListener('click', () => this.stepQty(1));

        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }

      stepQty(delta) {
        const current = parseInt(this.qtyInput.value || '1', 10);
        this.qtyInput.value = Math.max(1, current + delta);
      }

      handleOptionClick(btn) {
        const group = btn.closest('.kith-pdp__buttons');
        group.querySelectorAll('.kith-pdp__opt-btn').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.updateVariant();
      }

      getSelectedOptions() {
        const options = [];
        this.querySelectorAll('.kith-pdp__option').forEach((optionEl) => {
          const selected = optionEl.querySelector('.kith-pdp__opt-btn.is-selected');
          options.push(selected ? selected.dataset.value : null);
        });
        return options;
      }

      updateVariant() {
        const selected = this.getSelectedOptions();
        const match = this.variants.find((v) =>
          selected.every((val, i) => val === null || v.options[i] === val)
        );
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        const priceEl = document.getElementById('ProductPrice-' + this.sectionId);
        const idInput = document.getElementById('ProductSelectedVariant-' + this.sectionId);
        const skuEl = document.getElementById('ProductSku-' + this.sectionId);
        const invEl = document.getElementById('ProductInventory-' + this.sectionId);
        if (!match) return;

        idInput.value = match.id;
        if (priceEl) {
          const priceCurrent = priceEl.querySelector('.kith-pdp__price-current');
          if (priceCurrent) priceCurrent.textContent = this.formatMoney(match.price);
        }
        if (skuEl && match.sku) skuEl.textContent = match.sku;

        if (invEl) {
          const criticalThreshold = parseInt(invEl.dataset.criticalThreshold || '4', 10);
          const qty = match.inventory_quantity;

          let state = 'instock';
          let text = invEl.dataset.inStockText || 'En stock';

          if (!match.available) {
            state = 'outofstock';
            text = invEl.dataset.outStockText || 'Agotado';
          } else if (match.inventory_management && qty <= criticalThreshold && qty > 0) {
            state = 'critical';
            text = qty === 1
              ? (invEl.dataset.criticalStockTextSingular || 'ÚLTIMA UNIDAD EN TU TALLA')
              : (invEl.dataset.criticalStockText || 'ÚLTIMAS UNIDADES');
          }

          text = text.replace('{{quantity}}', qty);

          invEl.className = 'kith-pdp__inventory kith-pdp__inventory--' + state;

          if (state === 'critical') {
            invEl.innerHTML = '<span class="kith-pdp__inventory-badge">' + text + '</span>';
          } else {
            invEl.textContent = text;
          }
        }

        if (addBtn) {
          const label = addBtn.querySelector('[data-add-btn-text]');
          if (match.available) {
            addBtn.disabled = false;
            if (label) label.textContent = addBtn.dataset.addText || 'Agregar a la bolsa';
          } else {
            addBtn.disabled = true;
            if (label) label.textContent = addBtn.dataset.soldText || 'Agotado';
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      formatMoney(cents) {
        try {
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
          return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'CLP' ? 0 : 2,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      handleSubmit(e) {
        e.preventDefault();
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((r) => {
            if (!r.ok) throw new Error('add-to-cart-failed');
            return r.json();
          })
          .then(() => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-added');
            const label = addBtn.querySelector('[data-add-btn-text]');
            if (label) label.textContent = addBtn.dataset.addedText || 'Agregado ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              addBtn.classList.remove('is-added');
              this.updateVariant();
            }, 2000);
          })
          .catch(() => {
            addBtn.classList.remove('is-loading');
            this.form.submit();
          });
      }
    }
    customElements.define('product-form-kith', ProductFormKith);
  }

  (function () {
    document.querySelectorAll('.kith-pdp__image').forEach((img) => {
      img.addEventListener('click', () => img.classList.toggle('is-zoomed'));
    });

    document.querySelectorAll('.kith-pdp__gallery').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('.kith-pdp__media'));
      const dotsContainer = gallery.parentElement.querySelector('[data-gallery-dots]');
      if (!dotsContainer || slides.length < 2) return;

      dotsContainer.classList.add('has-dots');
      slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'kith-pdp__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
        dot.addEventListener('click', () => {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });

      const dots = Array.from(dotsContainer.children);
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx > -1) {
                dots.forEach((d) => d.classList.remove('is-active'));
                dots[idx].classList.add('is-active');
              }
            }
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    });

    document.querySelectorAll('[data-open-size-guide]').forEach((btn) => {
      const section = btn.closest('.kith-pdp');
      const modal = section ? section.querySelector('[data-size-guide-modal]') : null;
      if (!modal) return;
      btn.addEventListener('click', () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-close-size-guide]').forEach((el) => {
      el.addEventListener('click', () => {
        const modal = el.closest('[data-size-guide-modal]');
        if (modal) modal.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach((modal) => {
          modal.hidden = true;
          document.body.style.overflow = '';
        });
      }
    });

    document.querySelectorAll('.kith-pdp__related').forEach((container) => {
      const grid = container.querySelector('.kith-pdp__related-grid');
      const productId = container.dataset.productId;
      const limit = container.dataset.limit || 4;
      if (!grid || !productId) return;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
        .then((r) => r.json())
        .then((data) => {
          if (!data.products || !data.products.length) {
            container.style.display = 'none';
            return;
          }
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'CLP' ? 0 : 2,
          });
          grid.innerHTML = data.products
            .map((p) => {
              const img = p.featured_image || (p.images && p.images[0]) || '';
              return (
                '<a href="' + p.url + '" class="kith-pdp__related-card">' +
                '<div class="kith-pdp__related-image"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
                '<p class="kith-pdp__related-title">' + p.title + '</p>' +
                '<p class="kith-pdp__related-price">' + formatter.format(p.price / 100) + '</p>' +
                '</a>'
              );
            })
            .join('');
        })
        .catch(() => {
          container.style.display = 'none';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
